import React from 'react';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import utils from 'utils';

/**
 * LearnMoreAboutSkipTheCounterModal - Show a little description of what is skip the counter
 * @return {JSX} LearnMoreAboutSkipTheCounterModal component
 */

const LearnMoreAboutSkipTheCounterModal = () => (
  <Modal
    modalKey={MODAL.LEARN_MORE_ABOUT_SKIP_THE_COUNTER_MODAL}
    customClass='oci-stc-modal'
    theme={MODAL_THEMES.WHITE}
    header={utils.i18n('learn_more_about_skip_the_counter_modal_title')}
  >
    <div id={`${MODAL.LEARN_MORE_ABOUT_SKIP_THE_COUNTER_MODAL}_desc`}>
      <p>
        {utils.i18n('trip_card_skip_the_counter_description')} {utils.i18n('confirmation_stc_show_more_info')}
      </p>

      <p>{utils.i18n('confirmation_stc_show_more_list_description')}</p>
      <ul>
        <li>{utils.i18n('confirmation_stc_show_more_item_1')}</li>
        <li>{utils.i18n('confirmation_stc_show_more_item_2')}</li>
        <li>{utils.i18n('confirmation_stc_show_more_item_3')}</li>
      </ul>
    </div>
  </Modal>
);

export default LearnMoreAboutSkipTheCounterModal;
